import type {
  IDocezyFailedSyncList,
  IDocezyProvisionResponse,
  IDocezyStatus,
  IDocezySync
} from '@/interfaces/agency/integrations/docezy';
import axios from '@axios';

export default {
  getStatus() {
    return axios.get<IDocezyStatus>('/integrations/docezy/status');
  },

  provision() {
    return axios.post<IDocezyProvisionResponse>('/integrations/docezy/provision');
  },

  sync() {
    return axios.post<IDocezySync>('/integrations/docezy/sync');
  },

  getFailures(page = 1, limit = 50) {
    return axios.get<IDocezyFailedSyncList>('/integrations/docezy/sync/failures', {
      params: { page, limit }
    });
  }
};
